import {createStore, compose, applyMiddleware} from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";

export default function configureStore(initialState) {
    const store = createStore(reducers, initialState, compose(
        // applyMiddleware supercharges createStore with middleware:
        applyMiddleware(thunk),
        // Detect devtools browser extension
        (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production' && window.devToolsExtension) ? window.devToolsExtension() : fn => fn));
    return store;
}



// WEBPACK FOOTER //
// ./src/store.js